module.exports = __webpack_public_path__ + "static/media/Video-loop-Sun-Glaring-From-Trees.f6645ed5.mp4";